import React from 'react';
import { IMultiUserInvitePopupProps } from './types';
import SimplePopup from '../SimplePopup';
import { Container, Image, PopupInviteBlock, PopupText, PopupTitle } from './styles';
import { EnumTheme } from '../../../constants/enums';
import productImageSrc from 'assets/images/product/default-product-image_1.png';
import { ThemeButton } from '../../ThemedButton';
import { getPopUpSnapPoint } from '../../../utils/helpers';

export const MultiUserCancelPopup: React.FC<IMultiUserInvitePopupProps> = ({ isShow, onClose }) => {
  return (
    <SimplePopup show={isShow} close={onClose} snapPointToTop={getPopUpSnapPoint(400)}>
      <Container>
        <Image src={productImageSrc} />
        <PopupTitle>По ссылке ничего нет</PopupTitle>
        <PopupInviteBlock>
          <PopupText>
            Возможно, заказ уже оформлен или корзина была удалена. Если это не так — проверьте ссылку
          </PopupText>
          <ThemeButton use={EnumTheme.roundGhostGray} onClick={onClose}>
            Понятно
          </ThemeButton>
        </PopupInviteBlock>
      </Container>
    </SimplePopup>
  );
};
